export default function CaScienceAndTechnology() {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.1886 8.05957C9.92579 9.01663 8.73104 10.0603 7.61301 11.1831C2.34412 16.452 -0.32368 22.323 1.65123 24.2998C3.62614 26.2747 9.499 23.605 14.766 18.338C15.8889 17.2194 16.9326 16.024 17.8896 14.7606"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.8878 14.7601C20.9946 18.884 22.26 22.7635 20.726 24.2974C18.7492 26.2742 12.8782 23.6046 7.60935 18.3375C2.34416 13.0668 -0.323638 7.19761 1.65127 5.22085C3.18525 3.68872 7.06467 4.95407 11.1886 8.05909"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.2617 14.7607C10.2617 15.0064 10.3593 15.242 10.533 15.4157C10.7067 15.5894 10.9424 15.687 11.188 15.687C11.4337 15.687 11.6693 15.5894 11.843 15.4157C12.0168 15.242 12.1144 15.0064 12.1144 14.7607C12.1144 14.515 12.0168 14.2794 11.843 14.1057C11.6693 13.932 11.4337 13.8344 11.188 13.8344C10.9424 13.8344 10.7067 13.932 10.533 14.1057C10.3593 14.2794 10.2617 14.515 10.2617 14.7607ZM14.9118 6.69431C14.3283 6.59242 14.3283 5.75688 14.9118 5.65684C15.9425 5.47754 16.8965 4.99536 17.6521 4.27178C18.4077 3.5482 18.9307 2.61599 19.1544 1.59401L19.1877 1.43283C19.3137 0.858512 20.1326 0.854807 20.2622 1.42727L20.3067 1.61439C20.5388 2.63184 21.0664 3.55803 21.8232 4.27659C22.58 4.99516 23.5323 5.47406 24.5604 5.65313C25.1458 5.75503 25.1458 6.59613 24.5604 6.69617C23.5323 6.87525 22.58 7.35415 21.8232 8.07271C21.0664 8.79128 20.5388 9.71746 20.3067 10.7349L20.2622 10.922C20.1326 11.4963 19.3137 11.4926 19.1877 10.9183L19.1507 10.7571C18.927 9.73517 18.404 8.80296 17.6484 8.07937C16.8928 7.35579 15.9388 6.87361 14.9081 6.69431H14.9118Z"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
